export const NAME = 'home';

export const WHEN_6 = 6;
export const WHEN_12 = 12;